module.exports = __webpack_public_path__ + "img/ricelog_pinicon_013.4e54e205.png";